import { render, staticRenderFns } from "./UnitRub.vue?vue&type=template&id=ca6dd530"
import script from "./UnitRub.vue?vue&type=script&lang=js"
export * from "./UnitRub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports